export type SortBy = { field: string; direction: 'desc' | 'asc' } | Record<string, never>;

export const HeaderSortIcons: React.FC<{ field: string; sortBy: SortBy }> = ({ field, sortBy }) => {
  return (
    <div className="header-sort-icons">
      <span
        className={`header-sort-icon header-sort-icon__up ${
          field === sortBy.field && sortBy.direction === 'desc' ? 'active' : ''
        }`}
      >
        ▲
      </span>
      <span
        className={`header-sort-icon header-sort-icon__down ${
          field === sortBy.field && sortBy.direction === 'asc' ? 'active' : ''
        }`}
      >
        ▼
      </span>
    </div>
  );
};
